<template>
  <div class="login">
    <div class="language-con" v-if="isShowI18n">
      <Select v-model="currentLang" @on-change="changeLocale">
        <Option v-for="item in locales" :value="item.value" :key="item.value">
          {{ item.label }}
        </Option>
      </Select>
    </div>
    <div
      class="login-con"
      :style="{ width: loginConWidth, height: loginConHeight }"
    >
      <div class="login-con-left" :style="{ width: loginConLeftWidth }">
        <img
          v-if="isShowLogo"
          :src="logoImg"
          width="134"
          class="logo-img"
          alt="logo"
        />
        <Carousel
          autoplay
          :autoplay-speed="autoSpeed"
          loop
          radius-dot
          style="width: 100%; height: 100%"
        >
          <CarouselItem
            v-for="(item, index) in isSuccessSliderArr"
            :key="index"
          >
            <div class="login-carousel">
              <img :src="item" class="carousel_img" alt="img" />
            </div>
          </CarouselItem>
        </Carousel>
      </div>
      <div class="login-con-right">
        <div class="login-con-form">
          <div class="title" :style="{ marginTop: loginFormMarginTop }">
            {{ platformName }}
          </div>
          <div class="english-title">{{ platformEnglishName }}</div>
          <Form
            :model="loginFormData"
            label-position="top"
            class="ivu-login-form"
          >
            <FormItem :label="$t('portal.login.username')">
              <Input
                v-model="loginFormData.username"
                :placeholder="$t('portal.login.inputUsername')"
                :maxlength="100"
              >
                <Icon
                  custom="bsfit-icon bsfit-icon-yonghu-weishuru"
                  slot="prefix"
                ></Icon>
              </Input>
            </FormItem>
            <FormItem :label="$t('portal.login.password')">
              <Input
                id="usernameDiv"
                v-model="loginFormData.password"
                @on-enter="login"
                @keyup.enter="login"
                @on-click="showPwd = !showPwd"
                :type="showPwd ? 'password' : 'text'"
                :placeholder="$t('portal.login.inputPassword')"
                :icon="
                  showPwd
                    ? 'bsfit-icon bsfit-icon-mimaxianshi'
                    : 'bsfit-icon bsfit-icon-mimabuxianshi'
                "
              >
                <Icon
                  custom="bsfit-icon bsfit-icon-mima-weishuru"
                  slot="prefix"
                ></Icon>
              </Input>
            </FormItem>
            <FormItem
              :label="$t('portal.login.slider')"
              v-if="showVerify && showCheckCodeVerify"
            >
              <SliderVerificationCode
                :height="'38px'"
                ref="sliderCode"
                v-model="value"
              ></SliderVerificationCode>
            </FormItem>
            <FormItem
              :label="$t('portal.login.veriCode')"
              style="position: relative"
              v-if="showVerify && showPhoneVerify"
            >
              <Input
                v-model="loginFormData.phoneCode"
                :placeholder="$t('portal.login.veriCodeInfo')"
              >
                <Button
                  @click="showVerfyCodeForm = true"
                  v-if="!phCodeStatus"
                  slot="append"
                  style="color: #0d2db5"
                >
                  {{ $t("portal.login.getVeriCode") }}
                </Button>
                <Button v-else disabled slot="append" style="color: #adadad">
                  {{ reGetPhCodeTime }}
                </Button>
              </Input>
              <span
                v-if="phCodeStatus"
                style="color: #aaaaaa; position: absolute"
              >
                {{ phCodeTimeInfo }}
              </span>
            </FormItem>
            <div style="color: red">{{ errorMsg }}</div>
            <Button class="login-btn" @click="login">
              {{ $t("portal.login.loginText") }}
            </Button>
          </Form>
        </div>
      </div>
    </div>
    <!-- 验证码滑块 -->
    <Modal
      class="portal-modal"
      v-model="showVerfyCodeForm"
      :mask-closable="false"
      :footer-hide="true"
      :title="$t('portal.profile.saveValid')"
      width="400px"
      style="font-size: 14px"
    >
      <SliderVerificationCode
        style="width: 350px"
        :isLock="false"
        ref="sliderFormCode"
        :height="'38px'"
        v-model="value1"
      ></SliderVerificationCode>
    </Modal>
    <!-- 修改密码 -->
    <Modal
      class="portal-modal"
      v-model="showPwdModal"
      :title="$t('portal.profile.changePwd')"
      width="500px"
      style="font-size: 14px"
    >
      <Form
        class="form"
        ref="changePwdForm"
        :model="submitData"
        :rules="ruleValidate"
        :label-width="90"
        label-position="left"
        style="width: 80%; margin-top: 20px"
      >
        <FormItem :label="$t('portal.profile.newPwd')" prop="newPwd">
          <Input
            :type="newPwdIcon == 'visible' ? 'text' : 'password'"
            v-model="submitData.newPwd"
            :placeholder="$t('portal.profile.inputNewPwd')"
            :icon="newPwdIcon == 'visible' ? 'ios-eye-off' : 'ios-eye'"
            @on-click="
              newPwdIcon = newPwdIcon == 'visible' ? 'invisible' : 'visible'
            "
          />
        </FormItem>
        <FormItem :label="$t('portal.profile.confirmPwd')" prop="confirmPwd">
          <Input
            :type="confirmPwdIcon == 'visible' ? 'text' : 'password'"
            v-model="submitData.confirmPwd"
            :placeholder="$t('portal.profile.inputConfirmPwd')"
            :icon="confirmPwdIcon == 'visible' ? 'ios-eye-off' : 'ios-eye'"
            @on-click="
              confirmPwdIcon =
                confirmPwdIcon == 'visible' ? 'invisible' : 'visible'
            "
          />
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <Button type="info" class="cancel-btn" @click="pwdCancel">
          {{ $t("portal.profile.cancel") }}
        </Button>
        <Button type="info" class="ok-btn" @click="pwdSubmit">
          {{ $t("portal.profile.confirm") }}
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "@/utils/axios";
import sha256 from "sha256";
import Cookies from "js-cookie";
import { logoImg, prefix } from "./config";
import SliderVerificationCode from "./components/sliderCode";
import { getPhCode, getCarouselImg } from "@/api/user";
export default {
  name: "Login",
  data() {
    return {
      platformName: "",
      isShowI18n: true,
      platformEnglishName: "",
      loginFormData: {},
      timer: null,
      configTime: 60,
      logoUrl: "../../assets/img/login-log.png",
      showPwd: true,
      logoImg: logoImg,
      prefix: prefix,
      value: false,
      value1: false,
      showVerify: false,
      phCodeStatus: false,
      // isLock: false,
      showCheckCodeVerify: false,
      showEmailVerify: false,
      showPhoneVerify: false,
      showVerfyCodeForm: false,
      errorMsg: "",
      isSuccessSliderArr: [],
      userNameEmpty: false,
      passwordEmpty: false,
      currentLang: "zh-CN",
      autoSpeed: 5000,
      showPwdModal: false,
      submitData: {},
      genfunc: {},
      confirmPwdIcon: "invisible",
      newPwdIcon: "invisible",
      locales: [
        {
          value: "zh-CN",
          label: "简体中文",
        },
        {
          value: "en-US",
          label: "English",
        },
        // {
        //   value: "zh-TW",
        //   label: "繁体中文"
        // }
      ],
      isShowLogo: false,
    };
  },
  components: { SliderVerificationCode },
  computed: {
    phCodeTimeInfo() {
      if (!this.genfunc.phoneConfig) return;
      return `短信验证码已发送至用户手机，${parseInt(
        this.genfunc.phoneConfig.split(",")[1],
        10
      )}分钟内输入有效`;
    },
    reGetPhCodeTime() {
      if (!this.genfunc.phoneConfig) return;
      return `${this.configTime}秒后重新获取`;
    },
    checkCodeUrl() {
      return axios.defaults.baseURL + "/rs/generalfunction/checkcode";
    },
    isSmallScreen() {
      return window.screen.width <= 1600;
    },
    loginConWidth() {
      return this.isSmallScreen ? "900px" : "960px";
    },
    loginConHeight() {
      return this.isSmallScreen ? "470px" : "530px";
    },
    loginConLeftWidth() {
      return this.isSmallScreen ? "492px" : "556px";
    },
    loginFormMarginTop() {
      return this.isSmallScreen ? "68px" : "90px";
    },
    ruleValidate() {
      const validateNewPwd = (rule, value, callback) => {
        if (value === "") {
          callback();
        } else {
          if (
            this.genfunc &&
            this.genfunc.passwordLenMax &&
            this.genfunc.passwordLenMin
          ) {
            let min = Number.parseInt(this.genfunc.passwordLenMin);
            let max = Number.parseInt(this.genfunc.passwordLenMax);
            if (value.length < min || value.length > max)
              callback(
                new Error(this.$t("portal.profile.passwordValid1", [min, max]))
              );
          }
          if (this.genfunc && this.genfunc.passwordRules) {
            let arr = JSON.parse(this.genfunc.passwordRules);
            if (
              (arr.indexOf("数字") > -1 && !/\d/.test(value)) ||
              (arr.indexOf("英文字母") > -1 && !/[a-zA-Z]/.test(value)) ||
              (arr.indexOf("特殊字符") > -1 && !/[^0-9a-zA-Z]/.test(value)) ||
              (arr.indexOf("字母大小写") > -1 &&
                !(/[A-Z]/.test(value) && /[a-z]/.test(value)))
            ) {
              let arrText = [];
              arr.map(item => {
                if (item.indexOf("数字") > -1) {
                  arrText.push(this.$t("portal.profile.validate1"));
                } else if (item.indexOf("英文字母") > -1) {
                  arrText.push(this.$t("portal.profile.validate2"));
                } else if (item.indexOf("特殊字符") > -1) {
                  arrText.push(this.$t("portal.profile.validate3"));
                } else if (item.indexOf("字母大小写") > -1) {
                  arrText.push(this.$t("portal.profile.validate4"));
                }
              });
              callback(
                new Error(
                  this.$t("portal.profile.passwordValid2") + arrText.toString()
                )
              );
            }
          }
          callback();
        }
      };
      const validatePwd = (rule, value, callback) => {
        if (value === "") {
          callback();
        } else {
          if (this.submitData.newPwd != this.submitData.confirmPwd) {
            callback(new Error(this.$t("portal.profile.passwordValid3")));
          }
          callback();
        }
      };
      return {
        originPwd: [
          {
            required: true,
            message: this.$t("portal.profile.passwordValid4"),
            trigger: "change",
          },
        ],
        newPwd: [
          {
            required: true,
            message: this.$t("portal.profile.passwordValid5"),
            trigger: "change",
          },
          { validator: validateNewPwd, trigger: "change" },
        ],
        confirmPwd: [
          {
            required: true,
            message: this.$t("portal.profile.passwordValid6"),
            trigger: "change",
          },
          { validator: validatePwd, trigger: "change" },
        ],
      };
    },
  },
  mounted() {
    this.init();
    this.getLogoImg();
  },
  methods: {
    getLogoImg() {
      axios.get(`rs/logo/get?type=6&orderBy=1`).then(res => {
        if (Object.prototype.hasOwnProperty.call(res.data, "success")) {
          this.isShowLogo = false;
        } else {
          this.isShowLogo = true;
        }
      });
    },
    initImg() {
      getCarouselImg().then(res => {
        if (res.data.success) {
          this.isSuccessSliderArr = res.data.data;
        }
      });
    },
    getPhoneCode() {
      let username = this.loginFormData.username;
      let password = sha256(this.loginFormData.password);
      getPhCode({ loginName: username, password }).then(res => {
        if (res.data.success) {
          this.phCodeStatus = true;
          this.timer = window.setInterval(() => {
            if (this.configTime > 0) {
              this.configTime--;
            } else {
              window.clearInterval(this.timer);
              this.configTime = parseInt(
                this.genfunc.phoneConfig.split(",")[0],
                10
              );
              this.phCodeStatus = false;
            }
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
    init() {
      this.getLoginSecurityConfig();
      this.about();
      this.initImg();
    },
    getLoginSecurityConfig() {
      axios.get("rs/generalfunction/get").then(res => {
        if (res.data.success) {
          this.genfunc = res.data.data;
          this.configTime = parseInt(
            this.genfunc.phoneConfig.split(",")[0],
            10
          );

          let config = res.data.data;
          if (config.securityVerifySwitch === "不启用") {
            this.showVerify = false;
          } else if (config.securityVerifySwitch === "启用") {
            this.showVerify = true;
            if (config.securityVerifyMethod === "图形验证") {
              this.showCheckCodeVerify = true;
            }
            if (config.securityVerifyMethod === "邮箱验证") {
              this.showEmailVerify = true;
            }
            if (config.securityVerifyMethod === "短信验证") {
              this.showPhoneVerify = true;
            }
          }
        }
      });
    },

    about() {
      this.platformName = this.$store.state.platformName;
      this.isShowI18n = this.$store.state.useI18n;
      this.platformEnglishName = this.$store.state.platformEnglishName;
      this.currentLang = this.$store.state.lang || "zh-CN";
      this.$i18n.locale = this.currentLang;
      document.title = this.$t("portal.login.title");
    },

    changeCheckCode() {
      this.$refs.checkCodeImg.src = this.checkCodeUrl + "?num=" + Math.random();
    },

    pwdCancel() {
      this.showPwdModal = false;
    },
    pwdSubmit() {
      this.$refs.changePwdForm.validate(valide => {
        if (valide) {
          let formData = {};
          formData.newPwd = sha256(this.submitData.newPwd);
          formData.pwdToken = this.submitData.pwdToken;
          formData.username = this.submitData.username;
          axios.post("/changePwd", formData).then(resp => {
            if (resp.data.success) {
              this.$Message.success(this.$t("portal.profile.operSuccTip"));
              this.showPwdModal = false;
            } else {
              this.$Message.error(resp.data.error);
            }
          });
        } else {
          this.$Message.error(this.$t("portal.profile.checkInputTip"));
        }
      });
    },
    reload() {
      this.$refs["sliderCode"] && this.$refs["sliderCode"].reload();
    },
    login() {
      this.errorMsg = "";
      if (!this.loginFormData.username) {
        this.errorMsg = this.$t("portal.login.usernameNotEmpty");
        this.userNameEmpty = true;
        this.reload();
        return;
      }
      if (!this.loginFormData.password) {
        this.errorMsg = this.$t("portal.login.passwordNotEmpty");
        this.passwordEmpty = true;
        this.reload();
        return;
      }
      if (this.showVerify && this.showCheckCodeVerify && !this.value) {
        this.errorMsg = this.$t("portal.login.sliderFalse");
        this.reload();
        return;
      }
      if (this.showPhoneVerify && !this.loginFormData.phoneCode) {
        this.errorMsg = this.$t("portal.login.veriCodeInfo");
        this.reload();
        return;
      }
      let fd = {};
      for (let key in this.loginFormData) {
        if (Object.prototype.hasOwnProperty.call(this.loginFormData, key)) {
          let value = this.loginFormData[key];
          if (key === "password") {
            value = sha256(value);
          }
          fd[key] = value;
        }
      }

      const config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      };

      function urlencodeFormData(fd) {
        var s = "";
        function encode(s) {
          return encodeURIComponent(s).replace(/%20/g, "+");
        }
        for (let prop in fd) {
          if (Object.prototype.hasOwnProperty.call(fd, prop)) {
            s += (s ? "&" : "") + encode(prop) + "=" + encode(fd[prop]);
          }
        }
        return s;
      }
      axios
        .post("j_spring_security_check", urlencodeFormData(fd), config)
        .then(res => {
          if (res.data.success) {
            const result = res.data;
            const { hash } = window.location;
            if (result.token) {
              sessionStorage.setItem("token", result.token);
              Cookies.set("access_token", result.token, {
                expires: 1,
              });
            }
            window.location.href = result.targetUrl + hash;
          } else {
            this.reload();
            if (res.data.code === "user-multiplace-logined") {
              this.$Modal.confirm({
                content: this.$t("portal.login.userRepeateLogin"),
                onOk: () => {
                  axios.get("rs/user/saveIp?overwrite=true").then(() => {
                    window.location.href = res.data.targetUrl;
                  });
                },
              });
              return;
            } else if (res.data.code === "equalDefaultPwd") {
              this.$Modal.confirm({
                content: this.$t("portal.login.pwdSameDefaultTip"),
                onOk: () => {
                  this.showPwdModal = true;
                  this.submitData.username = res.data.username;
                  this.submitData.pwdToken = res.data.pwdToken;
                },
              });
              return;
            } else if (res.data.code === "pwdAlreadyInvalid") {
              this.$Modal.confirm({
                content: this.$t("portal.login.pwdReadyTip"),
                onOk: () => {
                  this.showPwdModal = true;
                  this.submitData.username = res.data.username;
                  this.submitData.pwdToken = res.data.pwdToken;
                },
              });
              return;
            } else if (res.data.code === "pwdReadyInvalid") {
              this.$Modal.confirm({
                content: this.$t("portal.login.pwdExpireTip"),
                onOk: () => {
                  sessionStorage.setItem("token", res.data.token);
                  Cookies.set("access_token", res.data.token, {
                    expires: 1,
                  });
                  window.location.href = "main.html#/sysconf/userProfile";
                },
              });
            }

            if (res.data.securityWay || res.data.verifyWay) {
              if (
                res.data.securityWay === "图形验证" ||
                res.data.verifyWay === "图形验证"
              ) {
                this.showVerify = true;
                this.showCheckCodeVerify = true;
              }
              if (res.data.securityWay === "邮箱验证") {
                this.showVerify = true;
                this.showEmailVerify = true;
              }
            }
            this.errorMsg = res.data.error;
          }
        });
    },

    //修改语言环境
    changeLocale(locale) {
      axios.get(`about/locale?locale=${locale}`).then(result => {
        if (result.data.success) {
          this.$i18n.locale = locale;
          this.init();
        }
      });
    },
  },
  watch: {
    showVerfyCodeForm(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs["sliderFormCode"] && this.$refs["sliderFormCode"].reload();
        });
      }
    },
    value1(val) {
      if (val) {
        this.verifyCodePass = true;
        this.showVerfyCodeForm = false;
        this.getPhoneCode();
      }
    },
    "loginFormData.username"(value) {
      if (value && this.userNameEmpty) {
        this.errorMsg = "";
        this.userNameEmpty = false;
      }
    },
    "loginFormData.password"(value) {
      if (value && this.passwordEmpty) {
        this.errorMsg = "";
        this.passwordEmpty = false;
      }
    },
  },
};
</script>

<style lang="less">
@import "./login.less";
.portal-modal {
  .ivu-modal-body {
    padding: 16px !important;
  }
}
</style>
